function hook(hookName) {
  return `[js-hook="${hookName}"]`;
}

export { hook as default };
